<div class="d-flex align-items-center justify-content-between m-b-16 p-x-20 p-t-16">
  <h3>{{action}} Employee</h3>
  <button
    mat-icon-button
    mat-dialog-close
    class="d-flex justify-content-center"
  >
    <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
  </button>
</div>

<!-- -------------------------------------------------------------- -->
<!-- Add Employee -->
<!-- -------------------------------------------------------------- -->

@if(action !== 'Delete') {
<mat-dialog-content>
  <form #userForm="ngForm">
    <div class="d-flex align-items-center m-b-16">
      <img
        class="mat-card-avatar"
        [src]="local_data.imagePath"
        class="rounded-circle"
        width="50"
        height="50"
      />
      <button mat-flat-button class="m-l-16 input-file-button">
        <input type="file" (change)="selectFile($event)" #fileInput />
      </button>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Name</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input
            type="text"
            matInput
            required
            id="name"
            name="name"
            [(ngModel)]="local_data.Name"
            placeholder="Name"
          />
        </mat-form-field>
      </div>
      <div class="col-lg-6">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Position</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input
            type="text"
            matInput
            required
            id="position"
            name="position"
            [(ngModel)]="local_data.Position"
            placeholder="Position"
          />
        </mat-form-field>
      </div>
      <div class="col-lg-6">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Email</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input
            type="text"
            matInput
            required
            id="email"
            name="email"
            [(ngModel)]="local_data.Email"
            placeholder="Email"
          />
        </mat-form-field>
      </div>
      <div class="col-lg-6">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block"
          >Mobile Number</mat-label
        >
        <mat-form-field appearance="outline" class="w-100">
          <input
            type="text"
            matInput
            required
            id="mobile"
            name="mobile"
            [(ngModel)]="local_data.Mobile"
            placeholder="Mobile"
          />
        </mat-form-field>
      </div>
      @if(action === 'Update') {
      <div class="col-lg-6">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Joining Date</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input
            matInput
            [matDatepicker]="picker"
            [formControl]="joiningDate"
            placeholder="Choose a date"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      }

      <div class="col-lg-6">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Salary</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input
            type="text"
            matInput
            required
            id="salary"
            name="salary"
            [(ngModel)]="local_data.Salary"
            placeholder="Salary"
          />
        </mat-form-field>
      </div>
      <div class="col-lg-6">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Projects</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input
            type="text"
            matInput
            required
            id="projects"
            name="projects"
            [(ngModel)]="local_data.Projects"
            placeholder="Projects"
          />
        </mat-form-field>
      </div>
    </div>
    <button
      mat-flat-button
      (click)="doAction()"
      mat-flat-button
      [disabled]="!userForm.valid"
    >
      {{action}}
    </button>
    <button
      mat-flat-button
      class="m-l-8 bg-error text-white"
      (click)="closeDialog()"
    >
      Cancel
    </button>
  </form>
</mat-dialog-content>
}
<!-- -------------------------------------------------------------- -->
<!-- Delete Employee info -->
<!-- -------------------------------------------------------------- -->

@else {
<div class="p-x-24 m-y-8">
  <p class="f-s-14">
    Sure to delete <span class="f-w-600">{{local_data.Name}}</span> ?
  </p>
</div>
<div mat-dialog-actions class="p-x-24 p-b-24">
  <button (click)="doAction()" mat-flat-button>{{action}}</button>
  <button
    mat-flat-button
    (click)="closeDialog()"
    class="m-l-8 bg-error text-white"
  >
    Cancel
  </button>
</div>
}
